<template>
  <div class="griddailog">
    <!--楼栋弹框-->
    <div class="wgModalXq" v-if="loudongValue">
      <div class="wgModalContent">
        <div class="title">
          <span class="titleError" @click="closeLoudongValue"
            ><img src="@/assets/images/cloud/closeIcon.png" alt=""
          /></span>
        </div>
        <img
          src="@/assets/images/cloud/triangleIcon.png"
          alt=""
          class="triangleIcon"
        />
        <div class="wgModalXqContent">
          <div class="wgModalXqContentLeft">
            <div class="eastContentRightZlSelect mb40">
              <el-select
                v-model="buildsectionName"
                placeholder="28#栋"
                style="width: 160px"
                disabled
              >
                <!-- <el-option
                                            v-for="item in optionsFloor"
                                            :key="item.floorValue"
                                            :label="item.floorLabel"
                                            :value="item.floorValue">
                                    </el-option> -->
              </el-select>
            </div>
            <img src="@/assets/images/cloud/build.png" alt="" class="build" />
          </div>
          <div class="wgModalXqContentRight">
            <div class="tab-con-content">
              <div class="width100">
                <div class="layui_card_subtitle">楼长：李亦非</div>
                <div>联系方式：13775698536</div>
              </div>
              <div>
                <div class="layui_card_subtitle">党员</div>
                <div class="layui_card_nums">
                  {{ buildparty }}
                </div>
              </div>
              <div>
                <div class="layui_card_subtitle">老人</div>
                <div class="layui_card_nums">
                  {{ buildoldAge }}
                </div>
              </div>
              <div>
                <div class="layui_card_subtitle">儿童</div>
                <div class="layui_card_nums">
                  {{ buildchildren }}
                </div>
              </div>
              <div>
                <div class="layui_card_subtitle">残疾人</div>
                <div class="layui_card_nums">
                  {{ builddisabilityPerson }}
                </div>
              </div>
              <div>
                <div class="layui_card_subtitle">孤寡老人</div>
                <div class="layui_card_nums">
                  {{ buildnooldPerson }}
                </div>
              </div>
              <div>
                <div class="layui_card_subtitle">低保老人</div>
                <div class="layui_card_nums">
                  {{ buildguaranteePerson }}
                </div>
              </div>
              <div>
                <div class="layui_card_subtitle">失独老人</div>
                <div class="layui_card_nums">
                  {{ buildoldPerson }}
                </div>
              </div>
              <div>
                <div class="layui_card_subtitle">优抚人员</div>
                <div class="layui_card_nums">
                  {{ buildhelpPerson }}
                </div>
              </div>
              <div class="width100">
                <div class="layui_card_subtitle">巡查人员：刘敏涛</div>
              </div>
              <div class="width100">
                <div class="layui_card_subtitle">
                  巡查时间：2020-7-22 08:00~2020-7-22 12:00
                </div>
              </div>
              <div class="width100">
                <div class="layui_card_subtitle">反馈情况：暂无问题</div>
              </div>
            </div>
            <div class="xcjl">
              <p class="font14 colorWhite mb5">巡查记录</p>
              <div class="xcjlContent">
                <p>上午</p>
                <div class="flexOne">
                  <div class="flexDirectionRow mb5">
                    <span class="mr8">签到：09:21:55</span>
                    <span class="mr8 flexOne">八公山路和平村28#栋</span>
                    <span class="zc">正常</span>
                  </div>
                  <div class="flexDirectionRow mb5">
                    <span class="mr8">签到：09:21:55</span>
                    <span class="mr8 flexOne">八公山路和平村28#栋</span>
                    <span class="yc">正常</span>
                  </div>
                </div>
              </div>
              <div class="xcjlContent">
                <p>上午</p>
                <div class="flexOne">
                  <div class="flexDirectionRow mb5">
                    <span class="mr8">签到：09:21:55</span>
                    <span class="mr8 flexOne">八公山路和平村28#栋</span>
                    <span class="zc">正常</span>
                  </div>
                  <div class="flexDirectionRow mb5">
                    <span class="mr8">签到：09:21:55</span>
                    <span class="mr8 flexOne">八公山路和平村28#栋</span>
                    <span class="yc">正常</span>
                  </div>
                </div>
              </div>
              <div class="xcjlContent">
                <p>上午</p>
                <div class="flexOne">
                  <div class="flexDirectionRow mb5">
                    <span class="mr8">签到：09:21:55</span>
                    <span class="mr8 flexOne">八公山路和平村28#栋</span>
                    <span class="zc">正常</span>
                  </div>
                  <div class="flexDirectionRow mb5">
                    <span class="mr8">签到：09:21:55</span>
                    <span class="mr8 flexOne">八公山路和平村28#栋</span>
                    <span class="yc">正常</span>
                  </div>
                </div>
              </div>
              <div class="xcjlContent">
                <p>上午</p>
                <div class="flexOne">
                  <div class="flexDirectionRow mb5">
                    <span class="mr8">签到：09:21:55</span>
                    <span class="mr8 flexOne">八公山路和平村28#栋</span>
                    <span class="zc">正常</span>
                  </div>
                  <div class="flexDirectionRow mb5">
                    <span class="mr8">签到：09:21:55</span>
                    <span class="mr8 flexOne">八公山路和平村28#栋</span>
                    <span class="yc">正常</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 没有楼栋数据的弹出框 -->
    <el-dialog
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      class="xinjianchuangkou"
      title="管理楼栋信息"
      @close="closeDialog"
      :visible.sync="newbuild"
      width="930px"
      :before-close="newbuildClose"
    >
      <el-form
        :rules="rules"
        :inline="true"
        :model="formInline"
        ref="formInline"
        label-width="100px"
        class="demo-form-inline formstyle"
      >
        <el-form-item label="所属网格" prop="sswg">
          <el-input v-model="formInline.sswg" placeholder="所属网格"></el-input>
        </el-form-item>
        <el-form-item label="网格长" prop="ldbm">
          <el-input v-model="formInline.ldbm" placeholder="网格长"></el-input>
        </el-form-item>

        <el-form-item label="小区名称" prop="xqmc">
          <el-input v-model="formInline.xqmc" placeholder="小区名称"></el-input>
        </el-form-item>
        <el-form-item label="楼栋名称" prop="ldmc">
          <el-input v-model="formInline.ldmc" placeholder="楼栋名称"></el-input>
        </el-form-item>
        <el-form-item label="楼栋层数" prop="ldcs">
          <el-input
            v-model="formInline.ldcs"
            :disabled="isView ? true : false"
            placeholder="楼栋层数"
          ></el-input>
        </el-form-item>
        <el-form-item label="楼栋单元数" prop="lddys">
          <el-input
            :disabled="isView ? true : false"
            v-model="formInline.lddys"
            placeholder="楼栋单元数"
          ></el-input>
        </el-form-item>
        <el-form-item label="每层户数" prop="mchs">
          <el-input
            :disabled="isView ? true : false"
            v-model="formInline.mchs"
            placeholder="每层户数"
          ></el-input>
        </el-form-item>
        <el-form-item label="楼栋性质" prop="lyxz">
          <el-select v-model="formInline.lyxz" placeholder="请选择楼宇性质">
            <el-option label="商住楼" value="0"></el-option>
            <el-option label="居民楼" value="1"></el-option>
            <el-option label="商居混合楼" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="建设单位" prop="jsdw">
          <el-input v-model="formInline.jsdw" placeholder="建设单位"></el-input>
        </el-form-item>
        <!--                <el-form-item label="建成日期" prop="jcrq">-->
        <!--                    <el-input v-model="formInline.jcrq" placeholder="建成日期"></el-input>-->
        <!--                </el-form-item>-->
        <el-form-item label="建成日期" prop="jcrq">
          <el-date-picker
            v-model="formInline.jcrq"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="建成日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="占地面积" prop="zdmj">
          <el-input v-model="formInline.zdmj" placeholder="占地面积"></el-input>
        </el-form-item>
        <!-- <el-form-item label="高度" prop="gd">
          <el-input v-model="formInline.gd" placeholder="高度"></el-input>
                </el-form-item>-->
        <el-form-item label="是否危房" prop="lyxz">
          <el-select v-model="formInline.isDanger" placeholder="请选择是否危房">
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="网格长照片" prop="gridPhoto" style="flex: 1">
          <div
            class="uploads"
            style="width: 95px; height: 95px; border: 1px solid #dedede"
          >
            <img :src="formInline.gridPhoto" alt width="100%" height="100%" />
          </div>
        </el-form-item>
        <el-form-item
          label="楼宇照片"
          prop="girduploadfilephoto"
          style="flex: 1"
        >
          <div class="uploads" style="width: 0px; height: 0px; border: none">
            <input
              type="file"
              value="uploading"
              ref="gird_up"
              id="file2"
              @change="uploadConfiggrid"
            />
          </div>
          <div class="uploads uploads-files" v-if="girduploadfilephoto != ''">
            <img :src="girduploadfilephoto" alt width="100%" height="100%" />
            <i
              class="el-icon-error"
              style="
                position: absolute;
                right: -5px;
                top: -5px;
                cursor: pointer;
              "
              @click.stop="closeIMG()"
            ></i>
          </div>
          <div
            class="uploads doorphoto"
            @click="up_click_girdhead"
            v-if="girduploadfilephoto == ''"
          >
            <span class="uoloaddoor">上传楼宇</span>
            <span class="iconfont icon-tianjia1 dooricon">+</span>
          </div>
        </el-form-item>
        <el-form-item class="is-lygk" label="楼栋概况" prop="lygk">
          <el-input
            type="textarea"
            v-model="formInline.lygk"
            placeholder="请输入楼宇概况"
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- ? upload grid head photo -->

      <div class="uploading">
        <el-button @click="submitform" size="small" type="primary"
          >提交</el-button
        >
        <el-button @click="resetForm()" size="small" type="primary"
          >清空表单</el-button
        >
        <input
          type="file"
          value="uploading"
          ref="file_up"
          id="file"
          @change="uploadConfig"
        />
        <!-- button点击时,触发input的点击事件 -->
        <!-- <button class="oplbtn" @click="up_click">选择文件</button>
                <button class="oplbtn" @click="up_file">上传</button>-->
        <!-- <button class="oplbtn" @click="downloadtemp">🌟下载楼宇信息模版</button> -->
        <a class="dowmloada" :href="uploadUrl" download="w3logo"
          >🌟下载楼宇信息模版</a
        >
        <span class="uplso">{{ this.uploadfilename }}</span>
      </div>
    </el-dialog>
    <!-- 有楼栋数据的弹出框 -->
    <el-dialog
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      class="seedialog"
      :title="loudongMsg.sectionName"
      :visible="seebuild"
      :close="closeDialog"
      width="957px"
      :before-close="seebuildClose"
    >
      <!-- <el-button class="addBtn" @click.stop="addUnit" size="mini">添加</el-button> -->
      <!-- :href="'http://121.40.26.248:9001/qianmi-wisdom-zhsq-web-api/admin/person/info/downloadPersonExcel?sectionMapId='+addId" -->
      <el-button
        class="editBtn"
        style="right: 214px"
        @click="eidtbuild"
        size="mini"
        >修改</el-button
      >
      <a @click="daochu(addId)">
        <el-button class="editBtn2" size="mini">导出</el-button>
      </a>
      <div style="display: none">
        <input @change="fileChange" id="speechUpload" type="file" />
      </div>
      <!-- <label  for="speechUpload" class="ImportBtn">
                <span class="up__speech-txt">导入居民</span>
            </label> -->
      <div style="display: none">
        <input @change="fileChangeqy" id="speechUploadqy" type="file" />
      </div>
      <!-- <label for="speechUploadqy" style="right: 280px;" class="ImportBtn">
                <span class="up__speech-txt">导入商户</span>
            </label> -->
      <label for="speechUpload" class="ImportBtn">
        <span class="up__speech-txt">导入</span>
      </label>
      <!-- 动态展示房子信息 -->
      <div class="fanzicard">
        <div v-for="(item, index) in loudongMsg.sectionCell" :key="index">
          <img
            @click="getloudongxuanzhong(item, index)"
            :class="{ imgActive: loudongxuanzhong == item }"
            src="../../../../assets/images/楼栋.png"
            alt
          />
          <div>{{ index + 1 }}单元</div>
        </div>
      </div>
      <!-- 四个查看按钮 -->
      <div v-show="loudongxuanzhong != 0" class="chakan">
        <img
          src="../../../../assets/images/sanjx.png"
          class="sjx"
          :style="{ left: sjxindex * 140 + 30 + 'px' }"
        />
        <div @click="chakanrenyuan">
          <img src="../../../../assets/images/an.png" alt />
          <div class="fontbox">查看人员状态333</div>
        </div>
        <div>
          <img src="../../../../assets/images/jk.png" alt />
          <div class="fontbox">查看实时监控</div>
        </div>
        <div>
          <img src="../../../../assets/images/rl.png" alt />
          <div class="fontbox">查看本周人流量</div>
        </div>
        <div>
          <img src="../../../../assets/images/sb.png" alt />
          <div class="fontbox">查看设备状态</div>
        </div>
      </div>
    </el-dialog>
    <!-- 点击单元内查看人员的弹出框 -->
    <el-dialog
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      class="renyuandialog seedialog"
      :title="loudongMsg.sectionName + loudongxuanzhong + '单元'"
      :visible.sync="seecell"
      width="957px"
      :before-close="seecellClose"
    >
      <div class="dddaior">
        <div class="smenbox">
          <div class="smen" style="margin-left: 50px">
            <img src="../../../../assets/images/door7.png" alt />
            <span>空房</span>
          </div>
          <div class="smen">
            <img src="../../../../assets/images/door.png" alt />
            <span>常住房</span>
          </div>
          <div class="smen">
            <img src="../../../../assets/images/door2.png" alt />
            <span>出租房</span>
          </div>
          <div class="smen">
            <img src="../../../../assets/images/door8.png" alt />
            <span>流动房</span>
          </div>
          <div class="smen">
            <img src="../../../../assets/images/door3.png" alt />
            <span>空置房</span>
          </div>
          <div class="smen">
            <img src="../../../../assets/images/door4.png" alt />
            <span>境外</span>
          </div>
          <div class="smen">
            <img src="../../../../assets/images/door5.png" alt />
            <span>未落户</span>
          </div>
          <div class="smen">
            <img src="../../../../assets/images/door6.png" alt />
            <span>商住房</span>
          </div>
        </div>
        <!-- 每一层 -->
        <div class="tierbox" v-for="(item, index) in danyuan" :key="index">
          <div class="tierdisplay">
            <span class="tierdisplaycard">
              {{ index + 1 }}层
              <i
                class="el-icon-error"
                @click.stop="closeTier(item, index + 1)"
                style="
                  cursor: pointer;
                  position: absolute;
                  top: -3px;
                  right: 11px;
                "
              ></i>
            </span>
          </div>
          <!-- 每一户 -->
          <!-- v-show="value.familyType != 5" -->
          <div
            @click="chakanrenyuanbtn(value)"
            class="tier"
            v-for="(value, ix) in item"
            :key="ix"
          >
            <div class="menbox">
              <!-- <span
                              @click.stop="open(value, item)"
                              class="close iconfont icon-huabanfuben"
                            ></span>-->
              <i
                class="el-icon-error close"
                @click.stop="open(value, item)"
                style="
                  cursor: pointer;
                  position: absolute;
                  top: -3px;
                  right: 11px;
                "
              ></i>
              <div class="men">
                <template v-if="!value.familyMold">
                  <img src="../../../../assets/images/door7.png" alt />
                </template>
                <template v-else>
                  <img
                    v-if="value.familyType == '0'"
                    src="../../../../assets/images/door.png"
                    alt
                  />
                  <img
                    v-if="value.familyType == 'null'"
                    src="../../../../assets/images/door.png"
                    alt
                  />
                  <img
                    v-if="value.familyType == '1'"
                    src="../../../../assets/images/door2.png"
                    alt
                  />
                  <img
                    v-if="value.familyType == '2'"
                    src="../../../../assets/images/door8.png"
                    alt
                  />
                  <img
                    v-if="value.familyType == '3'"
                    src="../../../../assets/images/door3.png"
                    alt
                  />
                  <img
                    v-if="value.familyType == '4'"
                    src="../../../../assets/images/door4.png"
                    alt
                  />
                  <img
                    v-if="value.familyType == '5'"
                    src="../../../../assets/images/door5.png"
                    alt
                  />
                  <img
                    v-if="value.familyType == '6'"
                    src="../../../../assets/images/door6.png"
                    alt
                  />
                </template>
              </div>
              <div style="textalign: center">
                {{ value.doorCode }}
              </div>
            </div>
          </div>
          <!-- 添加户按钮 -->
          <span @click="addmen(item)" class="addbtn iconfont">+</span>
        </div>
      </div>
    </el-dialog>
    <!-- 点击门的弹出框 -->
    <el-dialog
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      class="doorlog seedialog"
      :title="doorTitle.cellNum + '单元' + doorTitle.doorCode"
      :visible.sync="doorvis"
      width="957px"
      :before-close="doorvisClose"
    >
      <div class="user-btn">
        <el-button
          @click="adduser({}, 'add')"
          type="primary"
          size="mini"
          style="
            margin-left: 16px;
            margin-bottom: 20px;
            position: absolute;
            top: 8px;
            right: 60px;
          "
          >新增住户</el-button
        >
        <el-button
          @click="addenterprise({}, 'add')"
          type="primary"
          size="mini"
          style="margin-left: 16px; position: absolute; top: 8px; right: 150px"
          >新增企业</el-button
        >
      </div>
      <div class="userbox">
        <div
          style="position: relative"
          v-for="(item, index) in door"
          :key="index"
          class="user"
        >
          <span
            @click.stop="deleteyes(item)"
            class="deleteuser iconfont icon-huabanfuben"
          ></span>
          <div @click="adduser(item, 'reset')" class="imgbox">
            <img width="65px" :src="item.personPhoto" alt />
          </div>
          <div>姓名:{{ item.personName }}</div>
          <div>年龄:{{ item.personAge }}</div>
          <div>户籍所在地:{{ item.originPlace }}</div>
          <div>与户主关系:{{ item.relationshipName }}</div>
          <div>
            <img
              src="../../../../assets/images/dy-icon.png"
              v-if="item.partyType == '0' || item.partyType == '1'"
            />
            <img
              src="../../../../assets/images/cjr-icon.png"
              v-if="item.disabilityPerson == '0'"
            />
            <img
              src="../../../../assets/images/gglr-icon.png"
              v-if="item.nooldPerson == '0'"
            />
            <img
              src="../../../../assets/images/lset-icon.png"
              v-if="item.behindChildren == '0'"
            />
            <img
              src="../../../../assets/images/tyjr-icon.png"
              v-if="item.retireSoldier == '0'"
            />
            <img
              src="../../../../assets/images/zyz-icon.png"
              v-if="item.volunteer == '0'"
            />
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- addresident新增住户组件 -->
    <addresident
      :vis="addresidentVisible"
      :gridCode="gridCode"
      @close="addresidentclose"
      @reset="chakanrenyuanbtnreq"
      @resetrenyuan="chakanrenyuan"
    />
    <!-- addenterprise新增企业组件 -->
    <addenterprise
      :vis="addenterpriseVisible"
      @close="addenterpriseclose"
      @reset="chakanrenyuanbtnreq"
      @resetrenyuan="chakanrenyuan"
    />
    <!-- 新增住户的侧边框 -->
    <el-drawer
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      :before-close="handleClose"
      title="新增住户信息"
      :visible.sync="drawer"
      :with-header="false"
    >
      <el-form
        :model="numberValidateForm"
        ref="numberValidateForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="姓名">
          <el-input
            v-model="numberValidateForm.name"
            placeholder="姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="年龄">
          <el-input
            v-model="numberValidateForm.age"
            placeholder="年龄"
          ></el-input>
        </el-form-item>
        <el-form-item label="户籍所在地">
          <el-input
            v-model="numberValidateForm.huji"
            placeholder="户籍所在地"
          ></el-input>
        </el-form-item>
        <el-form-item label="与户主关系">
          <el-select v-model="numberValidateForm.gx" placeholder="与户主关系">
            <el-option label="本人" value="1001"></el-option>
            <el-option label="夫妻" value="1002"></el-option>
            <el-option label="父亲" value="1003"></el-option>
            <el-option label="母亲" value="1004"></el-option>
            <el-option label="岳父" value="1005"></el-option>
            <el-option label="岳母" value="1006"></el-option>
            <el-option label="长子" value="1007"></el-option>
            <el-option label="次子" value="1008"></el-option>
            <el-option label="长女" value="1009"></el-option>
            <el-option label="次女" value="1010"></el-option>
            <el-option label="其他" value="1011"></el-option>
            <el-option label="儿媳" value="1012"></el-option>
            <el-option label="孙子" value="1013"></el-option>
            <el-option label="孙女" value="1014"></el-option>
            <el-option label="女婿" value="1015"></el-option>
            <el-option label="租户" value="1016"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitdrawer()">提交</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
// 新增住户
import addresident from "./griddailog/addresident"
import addenterprise from "./griddailog/addenterprise"
import { getDaochuInform, changeInfor, downloadPartyExcel } from "@/api/api"
import request from "@/utils/request.js"
import { post } from "@/api/requrestHttp"
export default {
  data() {
    return {
      addId: "",
      uploadUrl:
        request.defaults.baseURL +
        "/admin/section/info/downloadSection?token=" +
        window.localStorage.token,
      // ? door upload photo and file
      girduploadfilephoto: "",
      girduploadfile: "", // ? door's  e.target.files[0]
      loading: false,
      // 新增住户表单
      numberValidateForm: {
        name: "",
        age: "",
        huji: "",
        gx: "",
      },
      // 新增用户传递的参数
      addusermsg: "",
      // 新增用户弹框
      addresidentVisible: false,
      gridCode: "",
      //新增企业弹窗
      addenterpriseVisible: false,
      // 侧边弹出框
      drawer: false,
      // 控制查看楼栋数据窗口
      seebuild: false,
      // 楼栋200保存的数据
      loudongMsg: "",
      // 单元被选中的数据
      loudongxuanzhong: 0,
      // 控制新建楼栋数据窗口
      newbuild: false,
      isView: false,
      // 新建楼栋数据表单
      formInline: {
        loudongID: "",
        sswg: "",
        sswgid: "",
        ldbm: "",
        ldmc: "",
        ldcs: "",
        lddys: "",
        mchs: "",
        xqmc: "",
        lyxz: "",
        lygk: "",
        sectionPhoto: "",
        jsdw: "",
        jcrq: "",
        zdmj: "",
        isDanger: "",
        gd: "",
      },
      sId: "", //修改楼宇的id
      filesList: [], //图片集合
      // 新建表单上传文件的文件名
      uploadfilename: "",
      // 新建表单上传的文件
      senddata: [],
      // 新建楼栋表单校验
      rules: {
        ldmc: [{ required: true, message: "必填项", trigger: "blur" }],
        ldcs: [{ required: true, message: "必填项", trigger: "blur" }],
        lddys: [{ required: true, message: "必填项", trigger: "blur" }],
        mchs: [{ required: true, message: "必填项", trigger: "blur" }],
        xqmc: [{ required: true, message: "必填项", trigger: "blur" }],
        ssjd: [{ required: true, message: "必填项", trigger: "blur" }],
        ssjwh: [{ required: true, message: "必填项", trigger: "blur" }],
        isDanger: [{ required: true, message: "必填项", trigger: "blur" }],
        lyxz: [{ required: true, message: "必填项", trigger: "change" }],
      },
      // 查看楼栋-查看单元-查看人员窗口
      seecell: false,
      // 每单元的用户数据
      danyuan: [],
      // 点击门后每一户的信息
      door: [],
      doorTitle: {}, //页面标题
      // 点击门之后的弹出框
      doorvis: false,
      test: [
        [
          { id: "63433", doorCode: "1001" },
          { id: "63433", doorCode: "1002" },
          { id: "63433", doorCode: "1003" },
        ],
        [
          { id: "63433", doorCode: "2001" },
          { id: "63433", doorCode: "2001" },
          { id: "63433", doorCode: "2001" },
        ],
        [
          { id: "63433", doorCode: "3001" },
          { id: "63433", doorCode: "3001" },
          { id: "63433", doorCode: "3001" },
        ],
        [
          { id: "63433", doorCode: "4001" },
          { id: "63433", doorCode: "4001" },
          { id: "63433", doorCode: "4001" },
        ],
      ],
      sjxindex: 0,
      showbuilding: 0,
      loudongValue: false,
      optionsFloor: [
        {
          floorValue: "全部",
          floorLabel: "楼栋一",
        },
        {
          floorValue: "选项2",
          floorLabel: "楼栋二",
        },
        {
          floorValue: "选项3",
          floorLabel: "楼栋三",
        },
        {
          floorValue: "选项4",
          floorLabel: "楼栋四",
        },
        {
          floorValue: "选项5",
          floorLabel: "楼栋五",
        },
        {
          floorValue: "选项6",
          floorLabel: "楼栋六",
        },
      ],
      floorValue: 0,
      buildparty: 0,
      buildoldAge: 0,
      buildchildren: 0,
      builddisabilityPerson: 0,
      buildnooldPerson: 0,
      buildguaranteePerson: 0,
      buildoldPerson: 0,
      buildhelpPerson: 0,
      buildsectionName: "",
    }
  },
  mounted() {
    // 监听楼栋的点击事件
    this.$Bus.$on("buildclick", (data, wgmc, wgid) => {
      console.log("监听楼栋的点击事件")
      this.showbuilding = 0
      this.buildunfold(data, this.showbuilding)
      this.addId = data
      // console.log(wgid);
      // ? store grid name in data
      this.formInline.sswg = wgmc
      this.formInline.sswgid = wgid
      this.gridCode = wgid
      // console.log(wgid);
    })
    // 监听楼栋的右键点击事件
    this.$Bus.$on("rightbuildclick", (data, wgmc, wgid) => {
      console.log("监听楼栋的右键点击事件")
      console.log(data)
      console.log(wgmc)
      console.log(wgid)
      this.showbuilding = 1
      this.addId = data.replace("right", "")
      this.buildunfold(this.addId, this.showbuilding)
      // console.log(wgid);
      // ? store grid name in data
      this.formInline.sswg = wgmc
      this.formInline.sswgid = wgid
      this.gridCode = wgid
      // console.log(wgid);
    })
  },
  beforeDestroy() {
    // 页面销毁前 取消所有事件总线的监听
    this.$Bus.$off()
  },
  components: {
    addresident,
    addenterprise,
  },
  methods: {
    // 关闭右键楼栋弹框
    closeLoudongValue() {
      this.loudongValue = false
    },
    // 右键弹窗获取数据
    getPersonStatistics() {
      post("/admin/person/info/personStatistics", {
        sectionMapId: this.addId,
      }).then((res) => {
        console.log(res)
        // 党员：party老人：oldAge 儿童：children 残疾人： disabilityPerson孤寡：nooldPerson低保guaranteePerson失独：oldPerson
        this.buildparty = res.content[0].partyMember
        this.buildoldAge = res.content[0].oldAge
        this.buildchildren = res.content[0].children
        this.builddisabilityPerson = res.content[0].disabilityPerson
        this.buildnooldPerson = res.content[0].nooldPerson
        this.buildguaranteePerson = res.content[0].guaranteePerson
        this.buildoldPerson = res.content[0].oldPerson
        this.buildhelpPerson = res.content[0].helpPerson
      })
    },
    //导出
    async daochu(id) {
      //let data = JSON.parse({sectionMapId: id})
      let data = changeInfor({ sectionMapId: id })
      let res = await downloadPartyExcel(data)
      const blob = new Blob([res], {
        type: "application/vnd.ms-excel",
      })
      const fileName = "人员信息表.xls"
      const linkNode = document.createElement("a")

      linkNode.download = fileName //a标签的download属性规定下载文件的名称
      linkNode.style.display = "none"
      linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
      document.body.appendChild(linkNode)
      linkNode.click() //模拟在按钮上的一次鼠标单击

      URL.revokeObjectURL(linkNode.href) // 释放URL 对象
      document.body.removeChild(linkNode)
      console.log(res)
    },
    downloadtemp() {
      this.$http
        .post("/admin/section/info/downloadSection", {})
        .then((resp) => {})
    },
    //删除楼层信息
    closeTier(item, index) {
      let _this = this
      _this
        .$confirm("此操作将永久删除该户楼层, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(() => {
          // 点击确认按钮,调用删除方法
          let formData = new FormData()
          formData.append("sectionMapId", _this.loudongId)
          formData.append("doorFloor", index)
          _this.$http
            .post("/admin/family/info/deleteFamilyFloor", formData)
            .then((resp) => {
              if (resp.code == 200) {
                _this.$message.success(resp.message)
                _this.chakanrenyuan()
              } else {
                _this.$message.warning(resp.message)
              }
            })
        })
    },
    //增加单元
    addUnit() {
      let _this = this
      _this.seebuild = true
      _this
        .$confirm("是否增加单元", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
        .then(() => {
          // 点击确认按钮
          _this.loudongMsg.sectionCell = _this.loudongMsg.sectionCell + 1
        })
    },

    async fileChange(event) {
      const file = event.target.files[0]
      this.loading = true
      let config = {
        headers: { "Content-Type": "multipart/form-data" },
      }
      let formData = new FormData()
      formData.append("sectionMapId", this.loudongId)
      formData.append("gridCode", this.formInline.sswgid)
      formData.append("file", file)
      let result = await this.$http.post(
        "/admin/person/info/inSectionExcel",
        formData,
        config
      )
      // this.getarticlelist();
      if (result.code == 200) {
        this.loading = false
        this.$message.success(result.message)
      } else {
        this.$message.warning(result.message)
      }
    },
    async fileChangeqy(event) {
      const file = event.target.files[0]
      this.loading = true
      let config = {
        headers: { "Content-Type": "multipart/form-data" },
      }
      let formData = new FormData()
      formData.append("sectionMapId", this.loudongId)
      formData.append("gridCode", this.formInline.sswgid)
      formData.append("file", file)
      let result = await this.$http.post(
        "/admin/enterprise/info/import",
        formData,
        config
      )
      // this.getarticlelist();
      if (result.code == 200) {
        this.loading = false
        this.$message.success(result.message)
      } else {
        this.$message.warning(result.message)
      }
    },
    //修改楼宇信息弹窗
    eidtbuild() {
      let formData = new FormData()
      formData.append("id", this.loudongId)
      formData.append("gridId", this.formInline.sswgid)
      this.$http
        .post("/admin/section/info/getSection", formData)
        .then((resp) => {
          if (resp.code == 200) {
            this.formInline = {
              sswg: resp.content.gridName,
              sswgid: resp.content.gridCode,
              ldbm: resp.content.sectionCode,
              ldmc: resp.content.sectionName,
              ldcs: resp.content.sectionFloor,
              lddys: resp.content.sectionCell,
              mchs: resp.content.sectionHouse,
              xqmc: resp.content.blockName,
              lyxz: resp.content.sectionNature,
              lygk: resp.content.sectionSurvey,
              gridPhoto: resp.content.gridPhoto,
              jsdw: resp.content.occupy,
              jcrq: resp.content.builtDate,
              zdmj: resp.content.buildCompany,
              isDanger: resp.content.isDanger,
              gd: resp.content.sectionHeight,
            }
            this.girduploadfilephoto = resp.content.sectionPhoto
            this.formInline.loudongID = resp.content.sectionMapId
            this.sId = resp.content.sid
            this.isView = true
            this.newbuild = true
            this.seebuild = false
          }
        })
    },
    deleteyes(e) {
      this.$confirm("此操作将永久删除该户数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 点击确认按钮,调用删除方法
          this.deleteuser(e)
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          })
        })
    },
    async deleteuser(e) {
      this.loading = true
      console.log(e.id)

      let formData = new FormData()
      formData.append("id", e.id)
      let result = await this.$http.post(
        "/admin/person/info/deletePersonById",
        { id: e.id }
      )
      // 判断 如果返回201,表示楼栋没有数据,打开新建楼栋数据窗口
      console.log(result)
      this.$message(result.message)
      this.chakanrenyuanbtnreq()
      this.loading = false
    },

    // 楼栋被点击时调用方法 判断被点击的楼栋有没有数据,来展开不同的窗口
    async buildunfold(id, showbuilding) {
      this.isView = false
      this.loudongId = id
      // 获取楼栋信息
      let formData = new FormData()
      formData.append("id", this.loudongId)

      let result = await this.$http.post(
        "/admin/section/info/getSection",
        formData
      )
      // 判断 如果返回201,表示楼栋没有数据,打开新建楼栋数据窗口
      console.log(result)
      if (result.code == 201) {
        this.newbuild = true
        // 将楼栋id保存在新建的表单里
        this.formInline.loudongID = id

        // 如果返回值里有数据,执行查看的方法
      } else if (result.code == 200) {
        console.log("wsshowbuilding")
        console.log(showbuilding)
        if (showbuilding == 0) {
          this.seebuild = true
        } else if (showbuilding == 1) {
          this.loudongValue = true
          this.getPersonStatistics()
          this.buildsectionName = result.content.sectionName
        }
        let res = result.content
        //  将楼栋单元数的字符串转换为数值型
        if (res.sectionCell != "") {
          res.sectionCell = parseInt(res.sectionCell)
        }
        this.loudongMsg = res
      } else {
        this.$message("获取楼栋信息失败")
      }
      this.$Bus.$emit("buildtrue", false)
    },
    adduser(val, ar) {
      this.addresidentVisible = true
      // this.addusermsg = val;
      this.$Bus.$emit("adduser", val, this.doorTitle, ar)
    },
    addenterprise(val, ar) {
      this.addenterpriseVisible = true
      // this.addusermsg = val;
      this.$Bus.$emit("addenterprise", val, this.doorTitle, ar)
    },
    // 侧边栏新增住户提交
    async submitdrawer() {
      this.loading = true
      let formData = new FormData()
      formData.append("familyCode", this.doorTitle.familyCode)

      formData.append("personName", this.numberValidateForm.name)
      formData.append("personAge", this.numberValidateForm.age)
      formData.append("originPlace", this.numberValidateForm.huji)
      // let relationshipname;
      if (this.numberValidateForm.gx == "1001") {
        formData.append("relationshipName", "本人")
      } else if (this.numberValidateForm.gx == "1002") {
        formData.append("relationshipName", "夫妻")
      } else if (this.numberValidateForm.gx == "1003") {
        formData.append("relationshipName", "父亲")
      } else if (this.numberValidateForm.gx == "1004") {
        formData.append("relationshipName", "母亲")
      } else if (this.numberValidateForm.gx == "1005") {
        formData.append("relationshipName", "长子")
      } else if (this.numberValidateForm.gx == "1006") {
        formData.append("relationshipName", "次子")
      } else if (this.numberValidateForm.gx == "1007") {
        formData.append("relationshipName", "长女")
      } else if (this.numberValidateForm.gx == "1008") {
        formData.append("relationshipName", "次女")
      } else if (this.numberValidateForm.gx == "1009") {
        formData.append("relationshipName", "其他")
      } else if (this.numberValidateForm.gx == "1010") {
        formData.append("relationshipName", "儿媳")
      } else if (this.numberValidateForm.gx == "1011") {
        formData.append("relationshipName", "孙子")
      } else if (this.numberValidateForm.gx == "1012") {
        formData.append("relationshipName", "孙女")
      } else if (this.numberValidateForm.gx == "1013") {
        formData.append("relationshipName", "女婿")
      } else if (this.numberValidateForm.gx == "1014") {
        formData.append("relationshipName", "租户")
      }
      formData.append("relationship", this.numberValidateForm.gx)
      let result = await this.$http.post(
        "/admin/person/info/insertPerson",
        formData
      )
      this.$message(result.message)
      if (result.code == 200) {
        this.handleClose()
      }
      this.chakanrenyuanbtnreq()
      this.loading = false
    },
    // 点击弹出框内单元的处理方法
    getloudongxuanzhong(item, index) {
      // console.log(item);
      this.loudongxuanzhong = item
      this.sjxindex = index
      console.log(index)
    },
    // 点击查看人员按钮后 出来门的表格
    async chakanrenyuan() {
      this.loading = true
      this.seebuild = false
      this.seecell = true
      let formData = new FormData()
      formData.append("SectionMapId", this.loudongId)
      formData.append("cellNum", this.loudongxuanzhong)
      let result = await this.$http.post(
        "/admin/family/info/findFamily",
        formData
      )
      //console.log(">>>>>>", result);
      if (result.content) {
        for (let index = 0; index < result.content.length; index++) {
          result.content[index] = result.content[index]
        }
      }
      this.danyuan = result.content
      this.loading = false
    },
    // 1.用户点击删除按钮 弹出确认提示框
    open(val, ite) {
      // console.log(ite);
      // console.log(ite.length);
      let len = ite.length

      this.$confirm("此操作将永久删除该户数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 点击确认按钮,调用删除方法
          this.deletemen(val, len)
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          })
        })
    },
    // 5.删除人员提示框
    open202(val, len) {
      this.$confirm("此户存在人员数据, 是否连同人员数据一起删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 6.点击确认,调用删除人员方法
          this.deleteren(val)
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          })
        })
    },
    // 7.删除人员
    async deleteren(val, len) {
      let formData = new FormData()
      formData.append("familyCode", val.familyCode)
      let result = await this.$http.post(
        "/admin/person/info/deletePersonList",
        formData
      )
      // 8.删除人员后,再次调用删除户方法
      this.deletemen(val)
    },
    // 2.删除户
    async deletemen(val, len) {
      // console.log(val);
      // console.log(len);
      let familyBoolean = false
      if (len == 1) {
        familyBoolean = true
      }
      let formData = new FormData()
      formData.append("familyCode", val.familyCode)
      formData.append("familyBoolean", familyBoolean)

      let result = await this.$http.post(
        "/admin/family/info/deleteFamilyById",
        formData
      )
      // console.log(result);
      // 3.如果返回值是202 说明户里有人员数据 需要先删除人员
      if (result.code == 202) {
        // 4.调用是否删除人员的提示框
        this.open202(val)
        return
      }
      // 9.因为户里没有人员 删除成功 调用查看方法刷新户数据
      this.chakanrenyuan()
      this.$message({
        type: "success",
        message: "删除成功!",
      })
    },
    // 添加户
    async addmen(val) {
      let value = JSON.parse(JSON.stringify(val))
      let last = value.pop()
      let familyBoolean = false
      let familyType = last.familyType //类型,为5时说明要新建本层第一户
      // console.log(familyType);
      // return;
      let doorCodeHide
      let familyCode

      // console.log(last);

      let doorCode = last.doorCode //门牌号
      //下面是要传的值
      let sectionMapId = last.sectionMapId //楼栋id
      let cellNum = last.cellNum //单元数
      let doorFloor = last.doorFloor //层数

      if (familyType != "5") {
        doorCode = parseInt(doorCode) + 1 //"101"
        doorCodeHide = "part_" + cellNum + "_" + doorCode
        familyCode = sectionMapId + doorCodeHide
        // console.log(doorCode);
        // 如果新建的是第一户
      } else {
        doorCode = doorFloor + "01"
        doorCodeHide = "part_" + cellNum + "_" + doorCode
        familyCode = sectionMapId + doorCodeHide
        familyBoolean = true
        familyType = "0"
      }

      let formData = new FormData()
      formData.append("sectionMapId", sectionMapId)
      formData.append("cellNum", cellNum)
      formData.append("doorFloor", doorFloor)
      formData.append("familyType", familyType)
      formData.append("doorCode", doorCode)
      formData.append("doorCodeHide", doorCodeHide)
      formData.append("familyCode", familyCode)
      formData.append("familyBoolean", familyBoolean)

      let result = await this.$http.post(
        "/admin/family/info/insertFamily",
        formData
      )
      // 刷新页面
      this.chakanrenyuan()
    },
    // 点击门的图片后
    chakanrenyuanbtn(item) {
      this.doorvis = true
      this.doorTitle = item
      // console.log(item);
      // return;
      // familyCode
      this.chakanrenyuanbtnreq(item)
    },
    // 上面调用此方法
    async chakanrenyuanbtnreq(val) {
      this.loading = true
      let formData = new FormData()
      formData.append("pageNo", 1)
      formData.append("pageSize", 10)
      formData.append("familyCode", this.doorTitle.familyCode)
      let result = await this.$http.post("/admin/person/info/findPerson", {
        pageNo: 1,
        pageSize: 10,
        familyCode: this.doorTitle.familyCode,
      })
      let res = result.content.list
      // console.log(res);
      this.door = res
      // this.message
      this.$message(result.message)
      this.loading = false
    },
    // 新建楼栋表单的提交按钮
    async submitform() {
      if (
        this.formInline.ldcs == "" ||
        this.formInline.lddys == "" ||
        this.formInline.mchs == "" ||
        this.formInline.isDanger == ""
      ) {
        this.$message({
          message: "请填写表单信息",
          type: "warning",
        })
        return
      }
      // ? every famaly's message array
      let doorarr = this.getuserdoor()
      // console.log(doorarr);
      let doorarrjson = JSON.stringify(doorarr)
      // console.log(doorarrjson);
      let config = {
        headers: { "Content-Type": "multipart/form-data" },
      }
      // return;
      this.loading = true
      let formData = new FormData()
      formData.append("sectionMapId", this.formInline.loudongID)
      formData.append("sectionCode", this.formInline.ldbm)
      formData.append("sectionName", this.formInline.ldmc)
      // ?  grid name formData
      formData.append("gridCode", this.formInline.sswgid)

      formData.append("gridName", this.formInline.sswg)
      formData.append("sectionFloor", this.formInline.ldcs)
      formData.append("sectionCell", this.formInline.lddys)
      formData.append("sectionHouse", this.formInline.mchs)
      formData.append("blockName", this.formInline.xqmc)
      formData.append("sectionFile", this.girduploadfile)
      formData.append("sectionNature", this.formInline.lyxz)
      formData.append("sectionSurvey", this.formInline.lygk)
      formData.append("builtDate", this.formInline.jcrq)
      formData.append("buildCompany", this.formInline.zdmj)
      formData.append("occupy", this.formInline.jsdw)
      formData.append("sectionHeight", this.formInline.gd)
      formData.append("isDanger", this.formInline.isDanger)
      formData.append("door", doorarrjson)
      if (this.sId != "") {
        formData.append("id", this.sId)
        let result = await this.$http.post(
          "/admin/section/info/updateSection",
          formData,
          config
        )
        if (result.code == 200) {
          this.$message("更新成功")
        } else {
          this.$message.warning(result.message)
        }
      } else {
        let result = await this.$http.post(
          "/admin/section/info/insertSection",
          formData,
          config
        )
        if (result.code == 200) {
          this.$message("提交成功")
        } else {
          this.$message.warning(result.message)
        }
      }
      this.newbuild = false
      this.resetForm()
      this.loading = false
    },
    // 提交时生成楼栋每一户的信息
    getuserdoor() {
      let id = this.formInline.loudongID //楼栋id
      let dy = this.formInline.lddys //楼栋单元数
      let cs = this.formInline.ldcs //楼栋层数
      let hs = this.formInline.mchs // 每层户数
      let door = [] //最外层数组
      // 第一层循环,生成单元数组
      for (let dyindex = 0; dyindex < dy; dyindex++) {
        let dys = []
        // 第二层循环,生成层数
        for (let csindex = 0; csindex < cs; csindex++) {
          let css = []
          // 第三层循环,生成户
          for (let hsindex = 0; hsindex < hs; hsindex++) {
            let hss = {}
            hss.sectionMapId = id
            hss.cellNum = dyindex + 1 //单元数
            hss.doorFloor = csindex + 1 //层数
            hss.familyType = 0 //户性质
            //拼门牌号
            let hssind = hsindex + 1
            hssind = hssind + ""
            if (hssind.length == 1) {
              hssind = "0" + hssind
            }
            hss.doorCode = hss.doorFloor + "" + hssind
            //默认门牌号
            hss.doorCodeHide = "part_" + hss.cellNum + "_" + hss.doorCode
            //户号
            hss.familyCode = id + "part_" + hss.cellNum + "_" + hss.doorCode //拼户号

            css.push(hss)
            // css = css.reverse();
          }
          dys.push(css)
        }
        dys = dys.reverse()
        door.push(dys)
      }
      return door
    },
    // ? upload door photo
    uploadConfiggrid(e) {
      console.log(e.target.files)
      let _this = this
      let files = e.target.files[0]
      this.girduploadfile = files
      if (!e || !window.FileReader) return // 看支持不支持FileReader
      let reader = new FileReader()
      reader.readAsDataURL(files) // 这里是最关键的一步，转换就在这里
      reader.onloadend = function () {
        _this.filesList.push({ src: reader.result })
        console.log(_this.filesList)
        _this.girduploadfilephoto = this.result
      }
    },
    // box点击时,触发input的点击事件
    up_click_girdhead() {
      this.$refs["gird_up"].click()
    },
    closeIMG(item, index) {
      this.girduploadfilephoto = ""
    },
    // 楼栋选择文件
    uploadConfig(e) {
      let formData = new FormData()
      formData.append("file", e.target.files[0])
      // console.log(e.target.files[0]);
      this.uploadfilename = e.target.files[0].name
      this.senddata = formData
    },
    // button点击时,触发input的点击事件
    up_click() {
      this.$refs["file_up"].click()
    },
    //楼栋上传文件
    async up_file() {
      this.loading = true
      let config = {
        headers: { "Content-Type": "multipart/form-data" },
      }
      let formData = this.senddata
      await this.$http.post(
        "/admin/person/info/inSectionExcel",
        formData,
        config
      )
      // this.getarticlelist();
      this.$message("上传成功")
      this.loading = false
    },
    // 新建楼栋表单的清空按钮
    resetForm() {
      this.formInline.ldbm = ""
      this.formInline.ldmc = ""
      this.formInline.ldcs = ""
      this.formInline.lddys = ""
      this.formInline.mchs = ""
      this.formInline.xqmc = ""
      this.formInline.jsdw = ""
      this.formInline.zdmj = ""
      this.formInline.lyxz = ""
      this.formInline.jcrq = ""
      this.formInline.isDanger = ""
      this.formInline.lygk = ""
      this.closeIMG()
    },
    closeDialog() {
      this.formInline.ldbm = ""
      this.formInline.ldmc = ""
      this.formInline.ldcs = ""
      this.formInline.lddys = ""
      this.formInline.mchs = ""
      this.formInline.xqmc = ""
      this.formInline.jsdw = ""
      this.formInline.zdmj = ""
      this.formInline.lyxz = ""
      this.formInline.jcrq = ""
      this.formInline.isDanger = ""
    },
    // 新建楼栋窗口
    newbuildClose() {
      this.newbuild = false
      this.girduploadfilephoto = ""
      this.girduploadfile = ""
    },
    // 查看楼栋窗口
    seebuildClose() {
      this.seebuild = false
    },
    // 查看人员窗口
    seecellClose() {
      this.seecell = false
    },
    // 查看men窗口
    doorvisClose() {
      this.doorvis = false
    },
    handleClose() {
      this.drawer = false
      this.numberValidateForm.name = ""
      this.numberValidateForm.age = ""
      this.numberValidateForm.huji = ""
      this.numberValidateForm.gx = ""
    },
    // 关闭添加人员对话框
    addresidentclose() {
      this.addresidentVisible = false
    },
    // 关闭添加企业对话框
    addenterpriseclose() {
      this.addenterpriseVisible = false
    },
  },
}
</script>
<style scoped>
.wgModalXq {
  width: calc(100% - 190px);
  height: calc(100% - 100px);
  position: absolute;
  top: 24px;
  left: 170px;
  background: rgba(0, 0, 0, 0.8);
  color: #fff;
  border-radius: 6px;
  z-index: 5;
}
.wgModalXqContent {
  margin-left: 16px;
  margin-right: 16px;
  display: flex;
  flex-direction: row;
  height: calc(100% - 30px);
}
.wgModalXqContentLeft {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.wgModalXqContentRight {
  flex: 1;
  margin-left: 20px;
  width: calc(100% - 180px);
}
.title {
  height: 30px;
  width: 100%;
  font-size: 14px;
  color: #ffffff;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.titleError {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translate(0, -50%);
  cursor: pointer;
}
.eastContentRightZlSelect {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}
.mb40 {
  margin-bottom: 40px;
}
.triangleIcon {
  position: absolute;
  width: 24px;
  height: 23px;
  left: -11px;
  top: 0;
}
.build {
  height: 60%;
}
.tab-con-content {
  display: flex;
  flex-wrap: wrap;
  margin: 5px 0;
}
.tab-con-content > div {
  flex-grow: 1;
  text-align: center;
  background: rgba(70, 70, 70, 0.8);
  margin: 5px;
  padding: 5px;
}
.wgModalXqContent .tab-con-content > div {
  flex-grow: 1;
  text-align: center;
  background: rgba(70, 70, 70, 0.8);
  margin: 5px;
  padding: 5px;
  width: 20%;
  font-size: 14px;
}
.tab-con-content > div:first-child {
  width: 100%;
  display: flex;
  line-height: 24px;
}
.tab-con-content > div:first-child .layui_card_subtitle {
  flex-grow: 1;
  text-align: left;
}
.eastContentRightZlSelect /deep/.el-input__inner {
  border-radius: 4px;
  border: 1px solid #a1d8e6;
  color: #ffffff;
  height: 28px;
  line-height: 28px;
  width: 100%;
  background: transparent;
}
.eastContentRightZlSelect /deep/.el-input__icon {
  line-height: 28px;
}
.eastContentRightZlSelect /deep/.el-select .el-input .el-select__caret {
  color: #ffffff;
}
.width100 {
  width: 100% !important;
  text-align: left !important;
}
.layui_card_subtitle {
  white-space: nowrap;
  font-size: 12px;
}
.layui_card_nums {
  font-size: 18px;
  font-weight: 600;
}
.triangleIcon {
  position: absolute;
  width: 24px;
  height: 23px;
  left: -11px;
  top: 0;
}
.xcjl {
  display: flex;
  flex-direction: column;
  background: rgba(70, 70, 70, 0.8);
  margin: 5px;
  padding: 12px;
  height: calc(100% - 365px);
  overflow-y: auto;
}
.font14 {
  font-size: 14px;
}
.colorWhite {
  color: #ffffff;
}
.mb5 {
  margin-bottom: 5px;
}
.xcjlContent {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 14px;
  margin-top: 8px;
}
.xcjlContent p {
  margin-right: 8px;
}
.flexOne {
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.flexDirectionRow {
  display: flex;
  flex-direction: row;
}
.flexDirectionRow .flexOne {
  text-align: center;
}
</style>
<style lang="less">
@import "./gridding.less";
</style>
<style lang="less">
@import "./gridscope.less";
.sjx {
  height: 30px;
  position: absolute;
  top: -30px;
}
.menbox {
  border-radius: 6px;
  position: relative;
  padding: 0px 14px 5px;
  border: 1px solid rgba(185, 230, 255, 0);
  // opacity: 0;
  transition: all 0.3s;
  .close {
    position: absolute;
    top: 0;
    right: 0;
    // background-color: #fff;
    border-radius: 50%;
    color: #e66060;
    font-size: 21px;
    opacity: 0;
  }
}
.menbox:hover {
  background-color: #589cd5;
  border: 1px solid #3a5772;
  div {
    color: aliceblue !important;
  }
  .close {
    opacity: 1;
  }
}
.tierbox {
  .addbtn {
    font-size: 32px;
    line-height: 32px;
    position: relative;
    top: 25px;
    background-color: #055195;
    border-radius: 50%;
    display: inline-block;
    width: 33px;
    height: 33px;
    color: #7cb2d5;
    cursor: pointer;
    text-align: center;
  }
}
// ? new grid head and floor photo upload box
.newuploadsBox {
  display: flex !important;
  width: 100%;

  .doorphoto {
    border: 1px solid #606266;
    border-radius: 4px;
    position: relative;
    .dooricon {
      position: absolute;
      left: 50%;
      top: 30%;
      font-size: 42px;
      color: #333;
      transform: translate(-50%, -50%);
    }
    .uoloaddoor {
      position: absolute;
      width: 60px;
      bottom: 0px;
      left: 50%;
      transform: translateX(-50%);
      display: inline-block;
    }
  }
  .uploads {
    // overflow: hidden;
    height: 95px;
    display: inline-block;
    width: 95px;
    position: relative;
    display: flex;
    border-radius: 3px;
    border: 1px solid #dedede;
    text-align: center;
    margin-right: 10px;
    .el-icon-error {
      position: absolute;
      right: -5px;
      top: -5px;
    }
  }
  #file2 {
    display: none;
  }
}
.dowmloada {
  height: 31px;
  position: relative;
  background-color: #3ac19f;
  border-radius: 3px;
  border: 0;
  color: #fff;
  margin-left: 5px;
  outline: none;
  -webkit-transition: all 0.4s ease, border-color 0.4s ease;
  transition: all 0.4s ease, border-color 0.4s ease;
  display: inline-block;
  text-decoration: none;
  line-height: 31px;
  padding: 0 8px;
  &:hover {
    background-color: #b94f8a;
  }
}

.deleteuser {
  position: absolute;
  top: 9px;
  right: 35px;
  border-radius: 50%;
  color: #60aae6;
  font-size: 21px;
  opacity: 0;
}
.user:hover .deleteuser {
  opacity: 1;
}
.editBtn {
  position: absolute;
  right: 190px;
  top: 8px;
  background: #add3e9;
  color: #606266;
  border: none;
}
.editBtn2 {
  position: absolute;
  right: 60px;
  top: 8px;
  background: #add3e9;
  color: #606266;
  border: none;
}
.addBtn {
  position: absolute;
  right: 190px;
  top: 8px;
  background: #add3e9;
  color: #606266;
  border: none;
}
.ImportBtn {
  position: absolute;
  right: 125px;
  top: 8px;
  background: #add3e9;
  color: #606266;
  border: none;
  border-radius: 3px;
  padding: 6px 15px;
  font-size: 12px;
}
.is-lygk {
  width: 100% !important;
  display: flex !important;
  .el-form-item__content {
    flex: 1;
  }
}
.userbox > div {
  color: #fff;
}
</style>
